
import {
  ref,
  computed,
  defineComponent,
} from 'vue'
import * as Yup from "yup";

export default defineComponent({
  name: 'base-select',
  props: {
    modelValue: {
      type: String,
      required: false,
    },
    id: {
      type: String,
      default: 'id-default',
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Введите значение',
      required: false,
    },
    clearable: {
      type: Boolean,
      default: true,
      required: false,
    },
    filterable: {
      type: Boolean,
      default: true,
      required: false,
    },
    size: {
      type: String,
      default: 'large',
      required: false,
    },
    options: {
      type: Array,
      default: () => [],
      required: false,
    },
    schema: {
      type: Object,
      default: null,
      required: false,
    },
    isValid: {
      type: Boolean,
      default: false,
      required: false,
    },
    errorMessage: {
      type: Array,
      default: () => [],
      required: false,
    },
  },
  setup(props, context) {
    const errorMessage = ref(props.errorMessage);

    const fieldSchema = Yup.object().shape(props.schema);

    const inputModelValue = computed({
      get() {
        return props.modelValue;
      },
      async set(value) {
        let inputValue = value;

        await fieldSchema.validate(
          { field: value },
          { abortEarly: false },
        )
          .then(value => {
            inputValue = value.field;
            errorMessage.value = null;
          })
            .catch(err => {
              errorMessage.value = err.errors[err.errors.length - 1];
            });

        context.emit('update:isValid', errorMessage.value && errorMessage.value.length ? false : true);
        context.emit('update:errorMessage', errorMessage);

        return context.emit('update:modelValue', inputValue);
      }
    });

    return {
      inputModelValue,
    }
  },
})
